import axios from "axios";
import { DonationURL } from "../../../config/UrlEndPoint";

export const URL = `${DonationURL}donationitem`;

export const DISTRIBUTION_URL = `${DonationURL}thk_distribution`;

// Get MergingList All For use Combobox data
export function getMergingListAll() {
  return axios.get(URL);
}

//Get By ID
export function getMergingListById(mergingListId) {
  return axios.get(`${URL}/${mergingListId}`);
}

// items => filtered/sorted result for table data
export function findMergingList(queryParams) {
  return axios.post(`${URL}/donation_merging`, queryParams);
}

// POST => POST: Create the mergingList on the server
export function createMergingList(mergingList) {
  return axios.post(URL, mergingList);
}

// UPDATE => PUT: update the mergingList on the server
export function updateMergingList(mergingList) {
  return axios.put(`${URL}/${mergingList.uuid}`, mergingList);
}

// UPDATE => Delete: Delete the mergingList on the server
export function deleteMergingList(uuid) {
  return axios.delete(`${URL}/${uuid}`);
}

export function saveMerging(params) {
  return axios.post(`${DISTRIBUTION_URL}/leftover`, params);
}
